import BasePolicy from '@/policies/BasePolicy.js';

export default class SlideDeckPolicy extends BasePolicy {
    viewAny(user) {
        return user.hasPermissionTo('view all slide decks') || user.hasGroupPermissionTo('view all slide decks');
    }

    create(user) {
        if (user.hasGroupPermissionTo('create a slide deck')) {
            return false;
        }

        return user.hasPermissionTo('create a slide deck');
    }

    update(user, slideDeck) {
        if (user.hasGroupPermissionTo('edit a slide deck')) {
            return user.isInAssetGroup(slideDeck);
        }

        return user.hasPermissionTo('edit a slide deck');
    }

    delete(user) {
        if (user.hasGroupPermissionTo('delete a slide deck')) {
            return false;
        }

        return user.hasPermissionTo('delete a slide deck');
    }

    archive(user) {
        if (user.hasGroupPermissionTo('archive a slide deck')) {
            return false;
        }

        return user.hasPermissionTo('archive a slide deck');
    }
}
